import { DomainBase } from "./DomainBase";

export  class Table extends DomainBase {
    constructor() {
        super();
        this.Name = "";
        this.Capacity = 0;
        this.IsInUse = false;
        this.Branch = null;
    }
}